import React, { Component } from 'react'
import isURL from 'validator/lib/isURL'
import isEmpty from 'validator/lib/isEmpty'
import isHexColor from 'validator/lib/isHexColor'
import isUppercase from 'validator/lib/isUppercase'
import PropTypes from 'prop-types'
import Ad from './Ad'
import {
  Button,
  Header,
  Icon,
  Divider,
  Image,
  Form,
  Message,
  Segment
} from 'semantic-ui-react'
import { withUser } from '../HOC'
import db from '../../helpers/db'
import Firebase from 'firebase/app'
import 'firebase/auth'

class Team extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      showSuccessMessage: false,
      errors: {},
      form: props.user.team || {
        city: 'Dixie State',
        name: 'Trailblazers',
        abbreviated: 'DSU',
        logo:
          'https://upload.wikimedia.org/wikipedia/en/thumb/6/6c/Dixie_State_Trailblazers_logo.svg/1200px-Dixie_State_Trailblazers_logo.svg.png',
        hexColor: '#ff0000'
      },
      advertisements: (props.user.team && props.user.team.advertisements) || []
    }
  }

  static propTypes = {
    user: PropTypes.object,
    syncTeam: PropTypes.func
  }

  setErrors = () => {
    const { city, name, logo, hexColor, abbreviated } = this.state.form
    const { advertisements } = this.state
    return {
      advertisements: advertisements.some(
        ad => !isURL(ad, { protocols: ['https'], require_protocol: true })
      ),
      city: isEmpty(city),
      name: isEmpty(name),
      abbreviated: isEmpty(abbreviated) || !isUppercase(abbreviated),
      logo: !isURL(logo, { protocols: ['https'], require_protocol: true }),
      hexColor: !isHexColor(hexColor)
    }
  }

  onChange = (e, { name, value }) => {
    this.setState(({ form }) => ({ form: { ...form, [name]: value } }))
  }

  onChangeAd = (index, value) => {
    this.setState(({ advertisements }) => ({
      advertisements: [
        ...advertisements.slice(0, index),
        value,
        ...advertisements.slice(index + 1)
      ]
    }))
  }

  addAdvertisement = e => {
    e.preventDefault()
    this.setState(({ advertisements }) => ({
      advertisements: [...advertisements, '']
    }))
  }

  removeAdvertisement = index => {
    this.setState(({ advertisements }) => ({
      advertisements: advertisements
        .slice(0, index)
        .concat(advertisements.slice(index + 1))
    }))
  }

  onSubmit = () => {
    this.setState(
      { loading: true, errors: this.setErrors(), showSuccessMessage: false },
      () => {
        if (Object.values(this.state.errors).includes(true))
          return this.setState({ loading: false })
        const { currentUser } = Firebase.auth()
        const { advertisements } = this.state
        return (this.props.user.team
          ? db.teams.update(this.props.user.team.id, {
              ...this.state.form,
              advertisements
            })
          : db.teams
              .create({
                ...this.state.form,
                advertisements,
                user: db.users.ref(currentUser.uid)
              })
              .then(doc =>
                db.users.update(currentUser.uid, {
                  team: doc
                })
              )
        )
          .then(() => this.setState({ showSuccessMessage: true }))
          .then(this.props.syncTeam)
          .catch(({ message }) => {
            this.setState(state => ({
              errors: { ...state.errors, generic: message }
            }))
          })
          .then(() => this.setState({ loading: false }))
          .catch(e => console.log(e))
      }
    )
  }

  render() {
    const { errors, showSuccessMessage } = this.state
    const advertisements = this.state.advertisements.map((ad, i) => {
      return (
        <Ad
          key={i}
          link={ad}
          error={!isURL(ad, { protocols: ['https'], require_protocol: true })}
          onChange={(e, { value }) => this.onChangeAd(i, value)}
          remove={() => this.removeAdvertisement(i)}
        />
      )
    })
    return (
      <Form
        error={Boolean(Object.keys(errors).filter(key => errors[key]).length)}
        onSubmit={this.onSubmit}
        loading={this.state.loading}
      >
        <h1>My Team</h1>
        <Divider />
        <Message error content={this.state.errors.generic} />
        {showSuccessMessage && <Message positive content={'Team updated'} />}
        <Form.Input
          onChange={this.onChange}
          value={this.state.form.city}
          name="city"
          icon="building"
          iconPosition="left"
          label="City / Institution Name"
          placeholder="Dixie State University"
        />
        {errors.city && <Message error content={'City must not be empty'} />}
        <Form.Input
          onChange={this.onChange}
          value={this.state.form.name}
          name="name"
          icon="pencil"
          iconPosition="left"
          label="Team Name"
          placeholder="Trailblazers"
        />
        {errors.name && <Message error content={'Name must not be empty'} />}
        <Form.Input
          onChange={this.onChange}
          value={this.state.form.abbreviated}
          name="abbreviated"
          icon="font"
          iconPosition="left"
          label="Abbreviated Name"
          placeholder="DSU"
        />
        {errors.abbreviated && (
          <Message
            error
            content={'Abbreviated must be non-empty and uppercase'}
          />
        )}
        <Image size="medium" src={this.state.form.logo} />
        <Form.Input
          onChange={this.onChange}
          value={this.state.form.logo}
          name="logo"
          icon="linkify"
          iconPosition="left"
          label="Logo Link (https)"
          placeholder="https://couchcoach.io/wp-content/uploads/2018/06/CClogoWHITE-300x188.png"
        />
        {errors.logo && (
          <Message error content={'logo URL must be a https protocol URL'} />
        )}
        <Form.Input
          style={{
            width: 100,
            height: 100,
            background: this.state.form.hexColor
          }}
          onChange={this.onChange}
          value={this.state.form.hexColor}
          type="color"
          name="hexColor"
          label="Controller Color"
        />
        {errors.hexColor && (
          <Message
            error
            content={'Controller color must be a valid hexadecimal color'}
          />
        )}
        <Divider />
        <h1 style={{ display: 'inline', margin: 10 }}>Advertisements</h1>
        <Button
          circular
          icon="plus"
          color="green"
          onClick={this.addAdvertisement}
        />
        {advertisements.length ? (
          advertisements
        ) : (
          <Segment placeholder>
            <Header icon>
              <Icon name="certificate" />
              <h3>About advertisements</h3>
              <h5>
                An advertisement consists of a link pointing to a valid image.
                When the game controller is scoring, users will be greeted with
                your advertisement where the play selections regularly appear.
              </h5>
              <h5>
                All advertisements will cycle throughout a game and receive
                equal display time.
              </h5>
            </Header>
          </Segment>
        )}
        <Form.Button fluid size="big" content="Save" color="green" />
      </Form>
    )
  }
}

export default withUser(Team)



// WEBPACK FOOTER //
// ./src/components/Admin/Team.jsx